import { forwardRef } from 'react';
import type { CSSProperties, MouseEvent, SVGProps } from 'react';

interface SvgIconProps extends Pick<SVGProps<SVGSVGElement>, 'onMouseEnter' | 'onMouseLeave'> {
  name: string;
  className?: string;
  style?: CSSProperties;
  onClick?: (ev: MouseEvent<SVGSVGElement>) => void;
}

const SvgIcon = forwardRef<SVGSVGElement, SvgIconProps>(({ name, ...props }, ref) => (
  <svg ref={ref} {...props}>
    <use xlinkHref={`/__spritemap#sprite-${name}`} />
  </svg>
));

SvgIcon.displayName = 'SvgIcon';

export default SvgIcon;
